import { defineMessages } from 'react-intl';
import { ADVISOR_CONNECTION_STATUSES } from 'store/features/company-advisor-connections/helpers';

export const connectionStatuses = defineMessages({
  [ADVISOR_CONNECTION_STATUSES.pendingSignUpByUser]: {
    id: 'admin.companies.advisors.connections.statuses.pending-sign-up',
    defaultMessage: 'Pending Signup',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingEthAddressFromUser]: {
    id: 'admin.companies.advisors.connections.statuses.pending-eth-address',
    defaultMessage: 'Pending Eth Address',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.pending-transaction-signing-by-both',
    defaultMessage: 'Pending Signing',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByUser]: {
    id: 'admin.companies.advisors.connections.statuses.pending-transaction-signing-by-user',
    defaultMessage: 'User Pending Signing ',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByCompany]: {
    id: 'admin.companies.advisors.connections.statuses.pending-transaction-signing-by-company',
    defaultMessage: 'Company Pending Signing',
  },
  [ADVISOR_CONNECTION_STATUSES.signedByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.signed',
    defaultMessage: 'Verified',
  },
  [ADVISOR_CONNECTION_STATUSES.rejectedByUser]: {
    id: 'admin.companies.advisors.connections.statuses.rejected',
    defaultMessage: 'Rejected',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusPendingAtUser]: {
    id: 'admin.companies.advisors.connections.statuses.soft.pending-at-user',
    defaultMessage: 'Pending',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusPendingValidationByUser]: {
    id: 'admin.companies.advisors.connections.statuses.soft.pending-validation-from-user',
    defaultMessage: 'Pending Sign Up/In',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusPendingApprovalByCompany]: {
    id: 'admin.companies.advisors.connections.statuses.soft.pending-approval-from-company',
    defaultMessage: 'Pending Admin Approval',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusAcceptedByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.soft.accepted-by-both',
    defaultMessage: 'Verified',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusRejectionConfirmedByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.soft.rejection-confirmed-by-both',
    defaultMessage: 'Rejected',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusDisapprovedByCompany]: {
    id: 'admin.companies.advisors.connections.statuses.soft.disapproved-by-admin',
    defaultMessage: 'Disapproved',
  },
});

export const connectionActions = defineMessages({
  confirmDelete: {
    id: 'admin.companies.advisors.connections.confirmDelete',
    defaultMessage: 'Are you sure you want to remove this advisor?',
  },
  deleted: {
    id: 'admin.companies.advisors.connections.deleted',
    defaultMessage: `{advisorName} was removed from {companyName}`,
  },
});

export const pageActions = defineMessages({
  invite: {
    id: 'admin.companies.advisors.connections.invite',
    defaultMessage: 'Invite',
  },
  edit: {
    id: 'admin.companies.advisors.connections.edit',
    defaultMessage: 'Edit',
  },
});



// WEBPACK FOOTER //
// ./src/ui/companies/edit/advisors/messages.js